import React from 'react';
import Swiper from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';

import './style.scss';


const ContentCarouselTripleDotted = ({ children }) => {
  const params = {
    lazy: true,
    slideClass: 'swiper-slide-point',
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
  };

  return (
    <Swiper {...params}>
      {children}
    </Swiper>
  );
};

export default ContentCarouselTripleDotted;
